var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 11.74 12.28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1611 0.0770264C10.9108 0.0770264 10.6413 0.17958 10.3609 0.372838L3.53866 5.07317C3.0995 5.37565 2.86035 5.78268 2.86035 6.21967C2.86025 6.65677 3.10378 7.06409 3.54304 7.36658L10.3712 12.0635C10.652 12.2569 10.9329 12.3556 11.1827 12.3556H11.183C11.4508 12.3556 11.6538 12.246 11.8121 12.0328C11.9681 11.8222 12.0284 11.5231 12.0284 11.1612V1.27859C12.0285 0.53762 11.7102 0.0770264 11.1611 0.0770264Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.31729 0.0720631L0.988444 0.071167C0.618179 0.071167 0.282959 0.372655 0.282959 0.743142V11.681C0.282959 12.0515 0.607128 12.3556 0.977592 12.3556H0.988942L1.31122 12.3538C1.68158 12.3538 2.01043 12.051 2.01043 11.6805V0.743939C2.01053 0.373451 1.68726 0.0720631 1.31729 0.0720631Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.2838,
    height: 12.2845,
    fill: "white",
    transform: "translate(0.0319824 0.071167)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.3a4b6a86.svg";
export { ForwardRef as ReactComponent };